module.exports = __webpack_public_path__ + "img/zalogo.0484c363.png";